export default __webpack_public_path__ + "2a09db85465da1ad787dfd4ab7153e6f.svg";